import { FormProvider, useForm } from "react-hook-form";
import { GetBorrow, GetBorrowAmountMax } from "store/api/borrow";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import BorrowAmount from "./Components/BorrowAmount";
import BorrowInfo from "./Components/BorrowInfo";
import BorrowSubmit from "./Components/BorrowSubmit";
import CoinDrawerSelect from "components/CoinDrawerSelect";
import { Grid } from "@mui/material";
import { checkIfRulesAreAccepted } from "utils/helpers/checkIfRulesAreAccepted";
import http from "config/http";
import { repeat } from "utils/helpers/interval";
import useAlertModal from "hooks/useAlertModal";
import useNotify from "hooks/useNotify";

let getBorrowAmountMaxInterval;

function Borrow({ onClose }) {
  const notify = useNotify();
  const alert = useAlertModal();
  const navigate = useNavigate();

  const [borrowInitial, setBorrowInitial] = useState();
  const [borrowAmountMax, setBorrowAmountMax] = useState();
  const [loading, setLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const coinId = +searchParams.get("borrow") || 1;

  const methods = useForm({
    defaultValues: {
      coinId,
      amount: "",
    },
  });

  const { reset } = methods;

  const getBorrow = async () => {
    try {
      const { data } = await http.get(GetBorrow(coinId));

      setBorrowInitial(data?.data);
    } catch (error) {
      checkIfRulesAreAccepted({ error, notify, alert, navigate });
    }
  };

  const getBorrowAmountMax = async (coinId) => {
    try {
      setLoading(true);

      const { data } = await http.get(GetBorrowAmountMax(coinId));

      setBorrowAmountMax(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (borrowInitial?.validSeconds && coinId) {
      getBorrowAmountMax(coinId);

      clearInterval(getBorrowAmountMaxInterval);

      getBorrowAmountMaxInterval = repeat({
        action: () => getBorrowAmountMax(coinId),
        time: borrowInitial?.validSeconds * 1000,
      });
    }

    return () => {
      clearInterval(getBorrowAmountMaxInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinId, borrowInitial]);

  const handleChangeCoin = (data) => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, borrow: data?.id });
  };

  const selectedCoin = useMemo(
    () => borrowInitial?.lisCoin?.find((coin) => coin?.id === coinId),
    [borrowInitial, coinId]
  );

  useEffect(() => {
    getBorrow();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reset((formValues) => ({
      ...formValues,
      amount: "",
      coinId,
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinId, reset]);

  return (
    <FormProvider {...methods}>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CoinDrawerSelect
              coinList={borrowInitial}
              onCoinClick={handleChangeCoin}
              selectedCoin={selectedCoin}
            />
          </Grid>

          <BorrowAmount
            loading={loading}
            borrowAmountMax={borrowAmountMax}
            selectedCoin={selectedCoin}
          />

          <BorrowInfo
            borrowAmountMax={borrowAmountMax}
            selectedCoin={selectedCoin}
          />

          <BorrowSubmit
            onClose={onClose}
            borrowAmountMax={borrowAmountMax}
            selectedCoin={selectedCoin}
          />
        </Grid>
      </form>
    </FormProvider>
  );
}

export default Borrow;
